import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
  name: 'dayCount',
})
export class DayCountPipe implements PipeTransform {
  date = new Date();

  transform(value) {
    if (!value) return 'NA';
    const createdDate = moment(value).format('YYYY-MM-DD');
    const todayDate = moment(this.date).format('YYYY-MM-DD');
    var start = moment(todayDate, 'YYYY-MM-DD');
    var end = moment(createdDate, 'YYYY-MM-DD');
    //Difference in number of days
    let format = moment.duration(start.diff(end));
    const year = Math.floor(format.asYears());
    const month = Math.floor(format.asMonths());
    const week = Math.floor(format.asWeeks());
    const days = format.asDays();
    if (year > 0) {
      return this.updateCount('year', year);
    } else if (month > 0) {
      return this.updateCount('month', month);
    } else if (week > 0) {
      return this.updateCount('week', week);
    } else {
      if (days == 0) {
        return 'Today';
      } else {
        return this.updateCount('day', days);
      }
    }
  }

  updateCount(type, number) {
    return `${number} ${type}${number > 1 ? 's' : ''} ago`;
  }
}
